import {request} from '@/util/scripts/request'
import service from '@/business/webcheck/scripts/service'

export function checkIP() {
  return new Promise((resolve, reject) => {
    let ip = ''
    request(service.clientIP)
      .then(({success, result}) => {
        if (success) ip = result
      })
      .catch(_ => null)
      .finally(() => resolve(ip))
  })
}